import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { CSS_PROPS, UNIFORM_PROPS } from 'common/constants/component-props';
import { FieldBBErrorType } from '../fields/constants';
import { defaultProps as fileUploadDefaultProps } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';

export const fileUploadField = ({
	dictionary,
}: CreationContextFor<typeof COMPONENT_TYPE.FILE_UPLOAD_FIELD>): CreatedBuildingBlock<
	typeof COMPONENT_TYPE.FILE_UPLOAD_FIELD
> =>
	createModel({
		type: COMPONENT_TYPE.FILE_UPLOAD_FIELD,
		editorProps: {
			[UNIFORM_PROPS.fieldErrorShow]: FieldBBErrorType.required,
		},
		componentProps: {
			[UNIFORM_PROPS.fieldPlaceholder]: dictionary.FILE_UPLOAD_FIELD.placeholder,
			[UNIFORM_PROPS.fileUploadMaxSizeMb]: fileUploadDefaultProps.fileUploadMaxSizeMb,
			[UNIFORM_PROPS.fieldError]: {
				[FieldBBErrorType.required]: dictionary.FILE_UPLOAD_FIELD.errorRequired,
				[FieldBBErrorType.fileSize]: dictionary.FILE_UPLOAD_FIELD.errorFileSize,
				[FieldBBErrorType.invalidFileType]: dictionary.FILE_UPLOAD_FIELD.errorInvalidFileType,
				[FieldBBErrorType.genericError]: dictionary.FILE_UPLOAD_FIELD.errorGeneric,
			},
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[CSS_PROPS.field.style.text.phColor]: 'rgba(0, 0, 0, 0.54)',
					},
				},
			},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.FILE_UPLOAD_FIELD>;
